import { render, staticRenderFns } from "./CouponPopup.vue?vue&type=template&id=23429dea&scoped=true"
import script from "./CouponPopup.vue?vue&type=script&lang=js"
export * from "./CouponPopup.vue?vue&type=script&lang=js"
import style0 from "./CouponPopup.vue?vue&type=style&index=0&id=23429dea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23429dea",
  null
  
)

export default component.exports